export enum TaxTariffType {
  TRANCHE_0_TO_2900_KWH = 'TRANCHE_0_TO_2900_KWH',

  TRANCHE_2901_TO_10000_KWH = 'TRANCHE_2901_TO_10000_KWH',

  TRANCHE_10001_TO_50000_KWH = 'TRANCHE_10001_TO_50000_KWH',

  TRANCHE_50001_TO_10000000_KWH = 'TRANCHE_50001_TO_10000000_KWH',

  TRANCHE_ABOVE_10000000_KWH_B2C = 'TRANCHE_ABOVE_10000000_KWH_B2C',

  TRANCHE_ABOVE_10000000_KWH_B2B = 'TRANCHE_ABOVE_10000000_KWH_B2B',

  TRANCHE_0_TO_1000_M3 = 'TRANCHE_0_TO_1000_M3',

  TRANCHE_1001_TO_170000_M3 = 'TRANCHE_1001_TO_170000_M3',

  TRANCHE_170001_TO_1000000_M3 = 'TRANCHE_170001_TO_1000000_M3',

  TRANCHE_1000001_TO_10000000_M3 = 'TRANCHE_1000001_TO_10000000_M3',

  TRANCHE_ABOVE_10000000_M3 = 'TRANCHE_ABOVE_10000000_M3',
}
